export function EmptyState() {
  return (
    <div className="w-full p-8 text-center">
      <p className="text-sm text-muted-foreground">No data available</p>
    </div>
  );
}
